// extracted by mini-css-extract-plugin
export var footer = "footer--footer--1D1Vh";
export var footer__wrapper = "footer--footer__wrapper--3fmrF";
export var footer__social = "footer--footer__social--2i8o_";
export var footer__proceeds = "footer--footer__proceeds--3HPtL";